import React,{useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { useScannerStore } from "../utils/store";


export default function ScannerProtectedRoute({ children }) {
  const { user } = useScannerStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user.isAuthenticated || user.role !== "scanner") {
      navigate("/scanner-login", { replace: true });
    }
  }, [user, navigate]);

  if (!user.isAuthenticated || user.role !== "scanner") {
    return null; // Prevent rendering before redirect
  }

  return children;
}
